// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconFbtc } from "../../../icons/mono/build/icon-fbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const FbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconFbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  FbtcIcon.displayName = 'FbtcIcon';
}

export default FbtcIcon;